// src/VerifyEmail.js
import React, { useEffect, useState } from "react";
import { auth } from "./firebase";
import { applyActionCode, sendEmailVerification } from "firebase/auth";
import { useNavigate, useSearchParams } from "react-router-dom";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("⏳ Verifying your email...");
  const [resendAvailable, setResendAvailable] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const oobCode = searchParams.get("oobCode");

    if (oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => {
          setMessage("✅ Email verified successfully! Redirecting to login...");
          setTimeout(() => navigate("/login"), 3000);
        })
        .catch((err) => {
          console.error(err);
          setMessage("❌ Verification failed. The link may be invalid or expired.");
          setResendAvailable(true);
        });
    } else {
      setMessage("❌ Verify your email first (check your spam folder).");
      setResendAvailable(true);
    }
  }, [searchParams, navigate]);

  const handleResend = async () => {
    if (auth.currentUser) {
      try {
        await sendEmailVerification(auth.currentUser);
        setMessage("📩 Verification email resent! Please check your inbox.");
        setResendAvailable(false);
      } catch (error) {
        console.error("Error resending email:", error);
        setMessage("⚠️ Could not resend verification email. Try again later.");
      }
    } else {
      setMessage("⚠️ You must be logged in to resend verification email.");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="p-6 bg-white shadow rounded-xl text-center">
        <h2 className="text-xl font-bold mb-2">
          Hello {auth.currentUser?.displayName || "User"} 👋
        </h2>
        <p className="mb-4">{message}</p>

        {resendAvailable && (
          <button
            onClick={handleResend}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            🔄 Resend Verification Email
          </button>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
